(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    // Note de commande : enregistrée dans le panier au fil de la saisie (elle survit aux changements de quantité)
    const root = (window.MeekoTheme && window.MeekoTheme.routes && window.MeekoTheme.routes.root) || '/';
    let timer;
    let saved;
    const save = (value) => {
      if (value === saved) return;
      saved = value;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      }).catch(() => { saved = undefined; });
    };
    const field = (e) => (e.target && e.target.closest ? e.target.closest('[data-cart-note]') : null);
    document.addEventListener('input', (e) => {
      const el = field(e);
      if (!el) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => save(el.value), 500);
    });
    document.addEventListener('change', (e) => {
      const el = field(e);
      if (!el) return;
      window.clearTimeout(timer);
      save(el.value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-banner]').forEach((hero) => {
      // Hauteur « plein écran » : on retire la hauteur de l'en-tête
      const setTop = () => { const top = hero.getBoundingClientRect().top + window.scrollY; hero.style.setProperty('--hb-top', `${Math.max(0, Math.round(top))}px`); };
      setTop();
      window.addEventListener('resize', setTop, { passive: true });

      const track = hero.querySelector('[data-hero-track]');
      const slides = track ? Array.from(track.children) : [];
      if (slides.length < 2) return;
      const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
      let index = 0;
      let timer;
      const delay = (parseInt(hero.dataset.autoplay, 10) || 0) * 1000;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const go = (i) => {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      };
      const mark = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i === index && dots[i] && dots[i].getAttribute('aria-current') === 'true') return;
        index = i;
        dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => { if (!delay || reduced || timer) return; timer = setInterval(() => go(index + 1), delay); };

      track.addEventListener('scroll', () => { window.requestAnimationFrame(mark); }, { passive: true });
      dots.forEach((d) => d.addEventListener('click', () => { stop(); go(parseInt(d.dataset.heroDot, 10)); }));
      hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => { stop(); go(index - 1); });
      hero.querySelector('[data-hero-next]')?.addEventListener('click', () => { stop(); go(index + 1); });
      ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => hero.addEventListener(ev, stop, { passive: true }));
      hero.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    // Dernières paires : affiche le message selon la taille choisie
    document.querySelectorAll('[data-low-stock-note]').forEach((note) => {
      const form = note.closest('form[data-product-form]');
      const section = form && form.dataset.section;
      const picker = section && document.querySelector(`[data-variant-picker="${section}"]`);
      const json = picker && picker.querySelector('[data-variants-json]');
      if (!form || !json) return;
      const variants = JSON.parse(json.textContent);
      const update = () => {
        const idInput = form.querySelector('[name="id"]');
        const v = idInput && idInput.value ? variants.find((x) => String(x.id) === String(idInput.value)) : null;
        note.hidden = !(v && v.low && v.available);
      };
      picker.addEventListener('change', () => window.setTimeout(update, 0));
      document.addEventListener('variant:change', (e) => { if (!e.detail || e.detail.section === section) update(); });
    });
  })();

  (() => {
    document.querySelectorAll('[data-gallery-wrap]').forEach((wrap) => {
      const gallery = wrap.querySelector('[data-gallery]');
      const thumbs = Array.from(wrap.querySelectorAll('[data-gallery-thumb]'));
      if (!gallery || !thumbs.length) return;
      const prev = wrap.querySelector('[data-gallery-prev]');
      const next = wrap.querySelector('[data-gallery-next]');
      const count = gallery.children.length;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;

      const go = (i) => {
        const target = Math.max(0, Math.min(count - 1, i));
        gallery.scrollTo({ left: target * gallery.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      };
      const mark = () => {
        current = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === current ? 'true' : 'false'));
        if (prev) prev.disabled = current <= 0;
        if (next) next.disabled = current >= count - 1;
        // Garde la miniature active visible dans sa colonne, sans faire défiler la page
        const t = thumbs[current];
        const box = t && t.parentElement;
        if (!box) return;
        if (t.offsetTop < box.scrollTop) box.scrollTo({ top: t.offsetTop, behavior: 'smooth' });
        else if (t.offsetTop + t.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: t.offsetTop + t.offsetHeight - box.clientHeight, behavior: 'smooth' });
      };

      thumbs.forEach((t, j) => t.addEventListener('click', () => go(j)));
      if (prev) prev.addEventListener('click', () => go(current - 1));
      if (next) next.addEventListener('click', () => go(current + 1));
      gallery.addEventListener('scroll', () => window.requestAnimationFrame(mark), { passive: true });
      window.addEventListener('resize', () => { gallery.scrollLeft = current * gallery.clientWidth; }, { passive: true });
      mark();
    });
  })();

  (() => {
    // Zoom : clic sur une photo -> plein écran ; clic sur la photo -> zoom x2,5 (souris : suit le curseur ; tactile : glisser).
    const dlg = document.querySelector('[data-zoom]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const track = dlg.querySelector('[data-zoom-track]');
    const slides = Array.from(track.children);
    const prev = dlg.querySelector('[data-zoom-prev]');
    const next = dlg.querySelector('[data-zoom-next]');
    const count = dlg.querySelector('[data-zoom-count]');
    const SCALE = 2.5;
    let index = 0;
    let zoomed = null;
    let pointer = 'mouse';

    // Image déjà en cache (taille de la galerie) tout de suite, puis version HD dès qu'elle est chargée
    const load = (i) => {
      [i - 1, i, i + 1].forEach((j) => {
        const img = slides[j] && slides[j].querySelector('img[data-src]');
        if (!img) return;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        const hi = new Image();
        hi.onload = () => { img.src = hi.src; };
        hi.src = img.dataset.hi;
      });
    };
    const update = () => {
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      load(index);
    };
    const unzoom = () => {
      if (!zoomed) return;
      const img = zoomed.querySelector('img');
      img.style.width = '';
      zoomed.classList.remove('is-zoomed');
      zoomed.scrollTop = 0; zoomed.scrollLeft = 0;
      zoomed = null;
      track.classList.remove('is-locked');
      dlg.classList.remove('is-zoomed');
    };
    const go = (i, smooth) => {
      unzoom();
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      update();
    };
    const pan = (slide, x, y) => {
      const r = slide.getBoundingClientRect();
      slide.scrollLeft = ((x - r.left) / r.width) * (slide.scrollWidth - slide.clientWidth);
      slide.scrollTop = ((y - r.top) / r.height) * (slide.scrollHeight - slide.clientHeight);
    };
    const zoomIn = (slide, x, y) => {
      const img = slide.querySelector('img');
      const ir = img.getBoundingClientRect();
      if (!ir.width) return;
      const relX = (x - ir.left) / ir.width;
      const relY = (y - ir.top) / ir.height;
      const sr = slide.getBoundingClientRect();
      track.classList.add('is-locked');
      dlg.classList.add('is-zoomed');
      slide.classList.add('is-zoomed');
      img.style.width = `${Math.round(ir.width * SCALE)}px`;
      zoomed = slide;
      if (pointer === 'mouse') { pan(slide, x, y); return; }
      slide.scrollLeft = relX * img.offsetWidth - (x - sr.left);
      slide.scrollTop = relY * img.offsetHeight - (y - sr.top);
    };
    const cleanup = () => { unzoom(); document.documentElement.classList.remove('zoom-open'); };
    const closeZoom = () => { if (dlg.open) dlg.close(); cleanup(); };
    const open = (i) => {
      dlg.showModal();
      document.documentElement.classList.add('zoom-open');
      go(i, false);
      window.requestAnimationFrame(() => go(i, false));
    };

    document.addEventListener('click', (e) => {
      const m = e.target.closest('[data-zoom-index]');
      if (m) { e.preventDefault(); open(Number(m.dataset.zoomIndex) || 0); }
    });
    document.addEventListener('keydown', (e) => {
      if (dlg.open) {
        if (e.key === 'Escape') { e.preventDefault(); closeZoom(); return; }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
        return;
      }
      const m = e.target.closest && e.target.closest('[data-zoom-index]');
      if (m && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(Number(m.dataset.zoomIndex) || 0); }
    });
    dlg.addEventListener('pointerdown', (e) => { pointer = e.pointerType || 'mouse'; });
    track.addEventListener('click', (e) => {
      const slide = e.target.closest('.zoom__slide');
      if (!slide) return;
      if (zoomed) { unzoom(); return; }
      if (e.target.tagName === 'IMG') zoomIn(slide, e.clientX, e.clientY);
      else closeZoom();
    });
    track.addEventListener('mousemove', (e) => { if (zoomed && pointer === 'mouse') pan(zoomed, e.clientX, e.clientY); });
    track.addEventListener('scroll', () => {
      if (zoomed) return;
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== index) { index = i; update(); }
    }, { passive: true });
    if (prev) prev.addEventListener('click', () => go(index - 1, true));
    if (next) next.addEventListener('click', () => go(index + 1, true));
    dlg.querySelector('[data-zoom-close]').addEventListener('click', closeZoom);
    dlg.addEventListener('close', cleanup);
    window.addEventListener('resize', () => { if (dlg.open && !zoomed) track.scrollLeft = index * track.clientWidth; }, { passive: true });
  })();

  (() => {
    // Alerte retour en stock (inscription enregistrée par l'app Globo Pre-order)
    document.querySelectorAll('[data-bis]').forEach((box) => {
      const section = box.dataset.bis;
      const picker = document.querySelector(`[data-variant-picker="${section}"]`);
      const productForm = document.querySelector(`form[data-product-form][data-section="${section}"]`);
      const json = picker && picker.querySelector('[data-variants-json]');
      const variants = json ? JSON.parse(json.textContent) : null;
      const soldOut = box.dataset.soldOut === 'true';
      const title = box.querySelector('[data-bis-title]');
      const input = box.querySelector('input[type="email"]');
      const submit = box.querySelector('[data-bis-submit]');
      const msg = box.querySelector('[data-bis-message]');
      let current = null;

      const getVariant = () => {
        if (!variants) return { id: box.dataset.variantId, available: !soldOut, size_label: '' };
        const idInput = productForm && productForm.querySelector('[name="id"]');
        const id = idInput ? idInput.value : '';
        return id ? variants.find((v) => String(v.id) === String(id)) || null : null;
      };
      const say = (text, ok) => {
        msg.textContent = text;
        msg.classList.toggle('is-success', !!ok);
        msg.classList.toggle('is-error', !ok);
        msg.hidden = false;
      };
      const update = () => {
        const v = getVariant();
        const show = v ? !v.available : soldOut;
        if (!show) { box.hidden = true; current = null; msg.hidden = true; return; }
        if ((current && current.id) !== (v && v.id)) msg.hidden = true;
        current = v;
        box.hidden = false;
        if (!v) title.textContent = box.dataset.titlePick;
        else if (v.size_label) title.textContent = box.dataset.titleSize.replace('__SIZE__', v.size_label);
        else title.textContent = box.dataset.titleDefault;
      };
      const refresh = () => window.setTimeout(update, 0);
      if (picker) picker.addEventListener('change', refresh);
      document.addEventListener('variant:change', (e) => { if (!e.detail || e.detail.section === section) refresh(); });
      window.setTimeout(update, 60);

      box.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (box.classList.contains('is-loading')) return;
        const v = getVariant();
        if (!v) { if (picker) picker.dispatchEvent(new CustomEvent('variant:missing')); return; }
        const email = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say(box.dataset.msgInvalid, false); input.focus(); return; }
        box.classList.add('is-loading');
        submit.disabled = true;
        const fd = new FormData();
        fd.append('product_id', box.dataset.productId);
        fd.append('variant_id', v.id);
        fd.append('shop', box.dataset.shop);
        fd.append('notification', 'email');
        fd.append('locale', box.dataset.locale);
        fd.append('content[keyLabel]', '{}');
        fd.append('is_notified', false);
        fd.append('source', 'web');
        fd.append('page', 'product');
        fd.append('page_url', window.location.href);
        fd.append('ran', Math.floor(Date.now() / 567));
        fd.append('email', email);
        try {
          const res = await fetch('/apps/preorder/service/newSubscribeBackInStock', { method: 'POST', body: fd, credentials: 'same-origin' });
          const data = await res.json();
          if (data && data.success) { say(box.dataset.msgSuccess, true); input.value = ''; }
          else if (data && data.key === 'bisSubscribeRegistered') say(box.dataset.msgRegistered, true);
          else if (data && data.key === 'bisSubscribeFail') say(box.dataset.msgInvalid, false);
          else say(box.dataset.msgError, false);
        } catch (err) {
          say(box.dataset.msgError, false);
        }
        box.classList.remove('is-loading');
        submit.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Recommandations Shopify filtrées : sans le modèle de la page (et 1 seul coloris par modèle si demandé),
    // complétées par les produits par défaut.
    document.querySelectorAll('[data-reco-src]').forEach(async (el) => {
      const limit = Number(el.dataset.recoLimit) || 4;
      const filter = el.dataset.recoFilter || 'exclude';
      const current = el.dataset.recoCurrent || '';
      const grid = el.querySelector('[data-recommendations-inner]');
      const tpl = el.querySelector('template[data-reco-fallback]');
      let items = [];
      try {
        const html = await (await fetch(el.dataset.recoSrc)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        items = Array.from(doc.querySelectorAll('[data-recommendations-inner] .reco-item'));
      } catch (err) { /* on garde l'affichage par défaut */ }
      if (tpl) items = items.concat(Array.from(tpl.content.querySelectorAll('.reco-item')));
      const handles = new Set([el.dataset.recoProduct || '']);
      const models = new Set();
      const picked = [];
      items.forEach((it) => {
        if (picked.length >= limit) return;
        const m = it.dataset.model || '';
        const h = it.dataset.handle || '';
        if (handles.has(h)) return;
        if (filter !== 'none' && current && m === current) return;
        if (filter === 'diverse' && m && models.has(m)) return;
        handles.add(h);
        models.add(m);
        picked.push(document.importNode(it, true));
      });
      if (!picked.length || !grid) return;
      grid.replaceChildren(...picked);
      el.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-quiz]').forEach((quiz) => {
      const intro = quiz.querySelector('[data-quiz-step="intro"]');
      const steps = Array.from(quiz.querySelectorAll('[data-quiz-step="question"], [data-quiz-step="size"]'));
      const results = Array.from(quiz.querySelectorAll('[data-quiz-result]'));
      const progress = quiz.querySelector('[data-quiz-progress]');
      const bar = progress && progress.querySelector('span');
      const nav = quiz.querySelector('[data-quiz-nav]');
      const max = Number(quiz.dataset.max) || 4;
      if (!intro || !steps.length || !results.length) return;

      const panels = [intro].concat(steps, results);
      const picks = steps.map(() => null);
      let size = '';
      let index = -1;

      const show = (panel, focus) => {
        panels.forEach((p) => { p.hidden = p !== panel; });
        const at = steps.indexOf(panel);
        if (progress) progress.hidden = at < 0;
        if (nav) nav.hidden = at < 0;
        if (bar && at >= 0) bar.style.width = `${Math.round(((at + 1) / steps.length) * 100)}%`;
        if (!focus) return;
        const heading = panel.querySelector('h1, h2');
        if (heading) heading.focus({ preventScroll: true });
        const top = quiz.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.6) quiz.scrollIntoView({ block: 'start' });
      };

      const cardsOf = (result) => Array.from(result.querySelectorAll('[data-quiz-card]'));
      // '' : pas de pointure choisie · id de variante : dispo dans la pointure · null : indisponible
      const variantOf = (card) => {
        if (!size) return '';
        const found = (card.dataset.variants || '').split(',').map((v) => v.split(':')).find((v) => v[0] === size);
        return found ? found[1] : null;
      };

      const render = (winner, second, focus) => {
        let shown = 0;
        cardsOf(winner).forEach((card) => {
          const variant = variantOf(card);
          const visible = variant !== null && shown < max;
          card.hidden = !visible;
          if (!visible) return;
          shown += 1;
          const url = card.dataset.url;
          card.href = variant ? `${url}${url.includes('?') ? '&' : '?'}variant=${variant}` : url;
        });
        const withSize = Boolean(size) && shown > 0;
        winner.querySelectorAll('[data-quiz-size]').forEach((el) => { el.textContent = size; });
        winner.querySelectorAll('[data-quiz-title-size]').forEach((el) => { el.hidden = !withSize; });
        winner.querySelectorAll('[data-quiz-title-all]').forEach((el) => { el.hidden = withSize; });
        const colorways = winner.querySelector('.quiz__colorways .grid');
        if (colorways) colorways.hidden = shown === 0;
        const wrap = winner.querySelector('[data-quiz-alt-wrap]');
        if (wrap) {
          wrap.hidden = !second;
          wrap.querySelectorAll('[data-quiz-alt]').forEach((b) => { b.hidden = !second || b.dataset.quizAlt !== second.dataset.quizResult; });
        }
        show(winner, focus);
      };

      const rank = () => {
        const scores = {};
        results.forEach((r) => { scores[r.dataset.quizResult] = 0; });
        picks.forEach((pick) => {
          if (!pick) return;
          pick.forEach((model, i) => { if (model in scores) scores[model] += i === 0 ? 2 : 1; });
        });
        const ranked = results
          .map((r, i) => ({ r, i, score: scores[r.dataset.quizResult] }))
          .sort((a, b) => b.score - a.score || a.i - b.i);
        // Un modèle sans aucun coloris dans la pointure choisie n'est pas proposé
        const inSize = ranked.filter((x) => !size || cardsOf(x.r).some((c) => variantOf(c)));
        return (inSize.length ? inSize : ranked).map((x) => x.r);
      };

      const finish = () => {
        const list = rank();
        index = steps.length;
        render(list[0], list[1] || null, true);
        const model = list[0].dataset.quizResult;
        document.dispatchEvent(new CustomEvent('quiz:result', { detail: { model, size } }));
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'quiz_result', quiz_model: model, quiz_size: size || undefined });
      };

      const go = (i) => {
        if (i >= steps.length) { finish(); return; }
        index = i;
        show(i < 0 ? intro : steps[i], true);
      };

      steps.forEach((step, i) => {
        const answers = Array.from(step.querySelectorAll('[data-quiz-answer]'));
        answers.forEach((btn) => {
          btn.addEventListener('click', () => {
            answers.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
            if (step.dataset.quizStep === 'size') {
              size = (btn.dataset.size || '').trim();
              picks[i] = [];
            } else {
              picks[i] = (btn.dataset.models || '').split(',').map((m) => m.trim()).filter(Boolean);
            }
            go(i + 1);
          });
        });
      });

      quiz.addEventListener('click', (e) => {
        if (e.target.closest('[data-quiz-start]')) { go(0); return; }
        if (e.target.closest('[data-quiz-back]')) { go(index - 1); return; }
        if (e.target.closest('[data-quiz-restart]')) {
          picks.fill(null);
          size = '';
          quiz.querySelectorAll('[data-quiz-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          go(0);
          return;
        }
        const alt = e.target.closest('[data-quiz-alt]');
        if (alt) {
          const current = alt.closest('[data-quiz-result]');
          const next = results.find((r) => r.dataset.quizResult === alt.dataset.quizAlt);
          if (next) render(next, current, true);
        }
      });

      // Éditeur de thème : affiche le bloc sélectionné
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          const panel = e.target;
          if (!panels.includes(panel)) return;
          if (panel.dataset.quizResult) render(panel, null, false);
          else show(panel, false);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Tant que le bandeau d'accroche est à l'écran, la barre d'achat (prix + bouton) reste visible sur mobile.
    const hero = document.querySelector('.section-sales-hero');
    const bar = document.querySelector('[data-sticky-atc]');
    if (!hero || !bar || !('IntersectionObserver' in window)) return;
    if (!(hero.compareDocumentPosition(bar) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-pinned', entry.isIntersecting);
    }).observe(hero);
  })();

  } catch(e) { console.error(e); }
})();
})();
